
import imageCompression from 'browser-image-compression';

export const compressImage = async (imageFile, fieldName) => {
  const options = {
    maxSizeMB: 1, // Máximo tamaño en MB después de la compresión
    maxWidthOrHeight: 1920, // Las imágenes se redimensionarán si son mayores que este tamaño
    useWebWorker: true // Utilizar web workers para procesar la compresión en un hilo secundario
  };

  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.debug(`Original size of ${fieldName}:`, imageFile.size / 1024 / 1024, 'MB');  // Tamaño original en MB
    console.debug(`Compressed size of ${fieldName}:`, compressedFile.size / 1024 / 1024, 'MB');  // Tamaño después de comprimir en MB
    return compressedFile
  } catch (error) {
    console.error('Error compressing', fieldName, error);
  }
};